import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { defineMessages, intlShape, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import { isAdmin } from '../../../helpers';

import {
  ToolbarAsyncAutocomplete,
  ToolbarSearchField,
} from '../../statelessComponents/TableToolbar/Forms';
import ToolbarContainer from '../../statelessComponents/TableToolbar/Container';
import ToolbarButton from '../../statelessComponents/TableToolbar/Button';

import s from './EnhancedTableToolbar.scss';

const messages = defineMessages({
  searchPlaceholder: {
    id: 'Discussions.EnhancedTableToolbar.searchPlaceholder',
    defaultMessage: 'Search for discussion...',
    description: 'Placeholder displayed on discussions page',
  },
  postEntryLabel: {
    id: 'Discussions.EnhancedTableToolbar.postEntryLabel',
    defaultMessage: 'Post an entry',
    description: 'Label displayed on discussions page',
  },
  selectMainGroupPlaceholder: {
    id: 'Discussions.EnhancedTableToolbar.selectMainGroupPlaceholder',
    defaultMessage: 'Start typing main group name',
  },
});

@injectIntl
@withStyles(s)
@connect(state => ({
  auth: state.auth,
}))
export default class EnhancedTableToolbar extends React.Component {
  static propTypes = {
    search: PropTypes.string.isRequired,
    loadOptionsTotal: PropTypes.number.isRequired,
    onSearchChange: PropTypes.func.isRequired,
    clearSearch: PropTypes.func.isRequired,
    openPostModal: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    auth: PropTypes.shape({}),
    loadOptions: PropTypes.func.isRequired,
    onMainGroupChange: PropTypes.func.isRequired,
    mainGroup: PropTypes.shape({
      _id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }),
    courseId: PropTypes.string.isRequired,
    mainGroupSearchValue: PropTypes.string.isRequired,
    changeMainGroupSearchField: PropTypes.func.isRequired,
    loading: PropTypes.bool,
  };

  static defaultProps = {
    mainGroup: null,
    auth: {},
    loading: false,
  };

  render() {
    const {
      search,
      onSearchChange,
      clearSearch,
      openPostModal,
      intl: { formatMessage },
      mainGroup,
      onMainGroupChange,
      loadOptions,
      loadOptionsTotal,
      auth,
      courseId,
      mainGroupSearchValue,
      changeMainGroupSearchField,
      loading,
    } = this.props;

    return (
      <ToolbarContainer styled loading={loading}>
        {isAdmin(auth) && !courseId && (
          <ToolbarAsyncAutocomplete
            input={{ value: mainGroup }}
            name="mainGroup"
            onBlur={() => null}
            onDrop={() => null}
            onFocus={() => null}
            onDragStart={() => null}
            meta={{}}
            loadOptionsTotal={loadOptionsTotal}
            inputPlaceholder={formatMessage(
              messages.selectMainGroupPlaceholder,
            )}
            changeSearchField={changeMainGroupSearchField}
            searchValue={mainGroupSearchValue}
            placeholder=""
            loadingPlaceholder=""
            onChange={onMainGroupChange}
            loadOptions={loadOptions}
            getOptionLabel={option => option.name}
            getOptionValue={option => option._id}
            defaultOptions
            isClearable
          />
        )}
        <ToolbarSearchField
          placeholder={formatMessage(messages.searchPlaceholder)}
          value={search}
          className={s.searchContainer}
          onChange={onSearchChange}
          clearSearch={clearSearch}
        />
        {(!isAdmin(auth) ||
          (isAdmin(auth) && mainGroup && !courseId) ||
          (isAdmin(auth) && !mainGroup && courseId)) && (
          <ToolbarButton
            data-test-id="X_dNCr_pTVv8REZPWmWvB"
            variant="outlined"
            title={messages.postEntryLabel}
            onClick={openPostModal}
            id="post-an-entry-button"
          />
        )}
      </ToolbarContainer>
    );
  }
}
